import { LineWrap } from './styles'

import type { LineInterface } from './interface'

const Line = ({ type = 'primary', style, id }: LineInterface) => (<LineWrap id={id} className="line-atom" type={type} style={style} />)

export default Line
